import { Styles, generateClasses } from 'netline-ui';

export const jsonViewerClasses = generateClasses('JsonViewer', [
  'root',
  'object',
  'array',
  'arrayItem',
  'key',
  'value',
] as const);

const styles: Styles = ({ theme: { spacing } }) => ({
  margin: spacing(-2),
  [`.${jsonViewerClasses.object}`]: {
    maxWidth: '90vw',
    paddingLeft: spacing(2),
    listStyleType: 'none',
    [`&.${jsonViewerClasses.arrayItem}`]: {
      paddingLeft: 0,
    },
  },
  [`.${jsonViewerClasses.array}`]: {
    paddingLeft: spacing(3),
  },
  [`.${jsonViewerClasses.key}`]: {
    fontWeight: 500,
  },
  [`pre.${jsonViewerClasses.value}`]: {
    maxWidth: '90vw',
    overflowX: 'auto',
  },
  '& pre': {
    margin: 0,
    fontSize: 12,
  },
});

export default styles;
